import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingCTASection() {
  return <Section id="pricing" className="pb-32" data-id="element-169">
      <div className="max-w-4xl mx-auto bg-gradient-to-b from-tactical-surface to-tactical-dark border border-tactical-cyan/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden box-glow" data-id="element-170">
        {/* Background effects */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-tactical-cyan/10 blur-[100px] rounded-full pointer-events-none" data-id="element-171"></div>
        <div className="absolute inset-0 bg-grid-pattern opacity-30 pointer-events-none" data-id="element-172"></div>

        <div className="relative z-10" data-id="element-173">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-174">SECURE THE IQ MAP TODAY</h2>
          <p className="text-xl text-slate-300 font-inter max-w-2xl mx-auto mb-10" data-id="element-175">
            Stop the "Invisible Delay" that is holding your child back. Give
            them the vision of a pro for the price of a single private lesson.
          </p>

          <div className="bg-tactical-dark/80 border border-tactical-surface2 rounded-2xl p-8 max-w-md mx-auto mb-10 backdrop-blur-sm" data-id="element-176">
            <div className="text-slate-400 font-inter mb-2" data-id="element-177">
              Total Value: <span className="line-through" data-id="element-178">$48.00</span>
            </div>
            <div className="flex items-center justify-center gap-2 mb-6" data-id="element-179">
              <span className="text-3xl text-tactical-cyan font-bold" data-id="element-180">$</span>
              <span className="text-7xl font-oswald font-bold text-white tracking-tighter" data-id="element-181">
                6
              </span>
              <span className="text-3xl text-tactical-cyan font-bold self-start mt-2" data-id="element-182">
                .39
              </span>
            </div>

            <Button className="w-full py-5 text-2xl mb-4" onClick={() => window.location.href = 'https://elitemindsetpress.com/cart/48021298053378:1'} data-id="element-183">
              GET INSTANT ACCESS
            </Button>

            <div className="flex items-center justify-center gap-4 text-sm text-slate-400 font-inter" data-id="element-184">
              <div className="flex items-center gap-1" data-id="element-185">
                <Lock className="w-4 h-4" data-id="element-186" /> Safe Checkout
              </div>
              <div className="w-1 h-1 bg-slate-600 rounded-full" data-id="element-187"></div>
              <div className="flex items-center gap-1" data-id="element-188">
                <ShieldCheck className="w-4 h-4" data-id="element-189" /> Instant Digital Delivery
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}